const projects = [
    {
      title: "Completionist Game",
      description:
        "A multiplayer browser-based word game built ground-up using HTML, CSS, JS, and Firebase.",
      link: "https://completionistgame.com",
    },
    {
      title: "PSYC Build-A-Brain Demo",
      description:
        "For my Cognitive Psychology class, I created an interactive demo to demonstrate the psychological process behind solving an algebra problem.",
      link: "https://psyc203.brettjames.dev",
    },
    {
      title: "Canvas to Notion Assignment Automation",
      description:
        "A script that utilizes a user's Canvas Calandar Feed and Notion Token to automatically convert Canvas assignments to to-do tasks in Notion.",
      link: "https://github.com/brettj27/canvas-to-notion",
    },
  ];
  
  export default projects;
  